<template>
    <el-form class="reset-form" ref='resetForm' :model='resetForm'>
        <div class="reset-form-title">重置密码</div>
        <el-form-item>
            <el-input type="text" v-model="resetForm.email" placeholder="邮箱" :disabled="true">
                <img slot="prefix" style="padding: 10px 10px;" src="./images/passwd.png">
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-input type="password" v-model="resetForm.newPw" placeholder="新密码">
                <img slot="prefix" style="padding: 10px 10px;" src="./images/passwd.png">
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button class="submitBtn" type="primary" @click="submitForm('resetForm')">重置密码</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import {http, apiJson, GetQueryString} from '@/utils/http'
import { Message } from 'element-ui';
export default {
    data () {
        return {
            resetForm: {
                email: '',
                newPw: ''
            }
        }
    },
    created () {
        let resetPassword =  encodeURIComponent(GetQueryString('resetPassword'))
        if(resetPassword) {
            http(`${apiJson.validresetparam}?resetPassword=${resetPassword}`, null, 'GET').then(res => {
                if(res.code == 0) {
                   Message.success('验证成功，请输入重置后的密码') 
                   this.resetForm.email = res.data
                }else {
                    Message.error(res.message)
                    this.$router.push('/login/findPwBe')
                }
            })
        } else {
            Message.error('重置密码错误，请先发送重置密码邮件')
            this.$router.push('/login/findPwBe')
        }
    },
    methods: {
      submitForm(resetForm) {
        this.$refs[resetForm].validate(valid => {
          if (valid) {
            http(apiJson.resetPwByEmail, this.resetForm)
            .then(res => {
                if (res.code == 0) {
                    Message.success('密码重置成功，正在跳转登录！')
                    this.$router.push('/login')
                } else {
                    Message.error('密码重置失败：' + res.message)
                }
            }).catch(err => {
                console.log(err)
                Message.error('接口错误')
            })
          } else {
            Message.warning('请填写新密码')
            return false;
          }
        });
      }
    }
}
</script>
<style lang="scss" scoped>
    .reset-form {
        &-title {
            margin-top: 80px;
            margin-bottom: 31px;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }
        .submitBtn {
            width: 100%;
            margin-top: 18px;
            color: #ffffff;
            font-size: 16px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/Login/resetPw.vue